import { MouseEventHandler } from 'react';
import { useNavigate } from 'react-router-dom';

import { Banner, Button, Flex } from '@spotify-internal/encore-web';

import { ConfidenceLogo } from '../Icons';
import { AnimatedLoginTitle } from './AnimatedLoginTitle';
import { ChartBackground } from './ChartBackground';
import { Footer } from './Footer';
import { LoginErrorMessage } from './LoginErrorMessage';

import styles from './LoginPage.module.css';

// eslint-disable-next-line @spotify-confidence/page-requires-tracking -- Pre-auth page in core-react cannot depend on tracking-react
export const LoginPage = ({
  onLogin,
  loading,
  error,
}: {
  onLogin?: MouseEventHandler<HTMLButtonElement>;
  loading?: boolean;
  error?: Error;
}) => {
  const navigate = useNavigate();

  return (
    <ChartBackground>
      <Flex
        className={styles.root}
        direction="column"
        alignItems="center"
        data-testid="login-page-root"
      >
        <Flex
          className={styles.main}
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <ConfidenceLogo className={styles.logo} color="currentColor" />
          <AnimatedLoginTitle />
          <div className={styles.container}>
            {error && (
              <Banner colorSet="negative" contextual role="alert">
                <LoginErrorMessage error={error} />
              </Banner>
            )}
            <Flex className={styles.actions} gap="base" justifyContent="center">
              <Button
                variant="primary"
                colorSet="inverted"
                size="large"
                fullWidth
                data-testid="login-button"
                onClick={onLogin}
                disabled={loading}
                isLoading={loading}
                loadingAriaLabel="Authenticating"
              >
                Log in
              </Button>
              <Button
                variant="secondary-bordered"
                semanticColor="textBase"
                size="large"
                fullWidth
                data-testid="signup-button"
                onClick={() => navigate('/signup')}
                disabled={loading}
              >
                Sign up
              </Button>
            </Flex>
          </div>
        </Flex>
        <Footer />
      </Flex>
    </ChartBackground>
  );
};
